
const routes = [
  {
    path: '/board',
    redirect: { name: 'BoardList' },
    meta: { layout: 'default' },
    children: [
      {
        path: 'list/:bbsId/:pstId?',
        name: 'BoardList',
        meta: { menu: 'board', keepAlive: true },
        component: () => import('@/pages/cmn/board/BoardListContainer.vue'),
        props: (route) => ({
          bbsId: route.params.bbsId || '',
          pstId: route.params.pstId || ''
        }),
      },
      {
        path: 'detail/:bbsId/:pstId',
        name: 'BoardDetail',
        meta: { menu: 'board', keepAlive: false },
        component: () => import('@/pages/cmn/board/BoardDetailContainer.vue'),
        props: (route) => ({
          bbsId: route.params.bbsId || '',
          pstId: route.params.pstId || ''
        }),
      },
      {
        path: 'add/:bbsId',
        name: 'BoardInsert',
        meta: { menu: 'board', keepAlive: false },
        component: () => import('@/pages/cmn/board/BoardInsertContainer.vue'),
        props: (route) => ({
          bbsId: route.params.bbsId || ''
        }),
      },
      {
        path: 'modify/:bbsId/:pstId',
        name: 'BoardUpdate',
        meta: { menu: 'board', keepAlive: false },
        component: () => import('@/pages/cmn/board/BoardUpdateContainer.vue'),
        props: (route) => ({
          bbsId: route.params.bbsId || '',
          pstId: route.params.pstId || ''
        }),
      },
    ]
  },
  {
    path: '/cms/:contsId',
    name: 'ContentsView',
    meta: { layout: 'default' },
    component: () => import('@/pages/cmn/cms/CmsDetailView.vue'),
    props: (route) => ({
      contsId: route.params.contsId || ''
    }),
  },
  {
    path: '/my-rsvt',
    redirect: { name: 'MyRsvtList' },
    meta: { layout: 'default' },
    children: [
      // 마이페이지 예약내역
      {
        path: 'list',
        name: 'MyRsvtList',
        meta: { layout: 'default', menu: 'my-rsvt' },
        component: () => import('@/pages/myRsvt/MyRsvtListView.vue'),
      },
      {
        path: 'detail/:type',
        name: 'RsvtDetail',
        meta: { layout: 'default', menu: 'my-rsvt' },
        component: () => import('@/pages/myRsvt/MyRsvtDetailContainer.vue'),
        props: true
      }
    ]
  }
]

export default routes


